export default __webpack_public_path__ + "static/media/AgileDevelopment300.d587b3de.jpg";